import { Link } from "react-router-dom";
import { ShieldCheck, MapPin, Mail, Phone } from "lucide-react";
import MSLogo from "./MSLogo";

/**
 * Premium footer — kimlikli tasarım, tüm oturumlu sayfalarda görünür.
 * Data-testid: premium-footer
 */
export default function PremiumFooter() {
  return (
    <footer
      className="border-t border-white/8 bg-black/40 mt-16"
      data-testid="premium-footer"
    >
      <div className="max-w-[1800px] mx-auto px-4 sm:px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-[11px]">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-3">
              <MSLogo size={40} />
              <div className="font-display text-lg tracking-widest" style={{ color: "var(--gold)" }}>
                MİLYEMSOFT
              </div>
            </div>
            <div className="text-neutral-400 leading-relaxed text-[11px] max-w-md">
              Kuyumcular için canlı Harem Altın kur yayını, POS, cari hesap ve AI destekli tam kapsamlı yönetim platformu.
              AES-256 · JWT · İzole Kasa · KVKK Uyumlu.
            </div>
          </div>

          <div>
            <div className="label-caps mb-2.5 text-[10px]" style={{ color: "var(--gold)" }}>Yasal</div>
            <ul className="space-y-1.5 text-neutral-400 font-mono tracking-wide">
              <li><Link to="/legal/mesafeli-satis" className="hover:text-white">Mesafeli Satış</Link></li>
              <li><Link to="/legal/gizlilik-kvkk" className="hover:text-white">KVKK / Gizlilik</Link></li>
              <li><Link to="/legal/kullanim-kosullari" className="hover:text-white">Kullanım Koşulları</Link></li>
              <li><Link to="/legal/iptal-iade" className="hover:text-white">İptal / İade</Link></li>
              <li><Link to="/legal/hizmet-teslimati" className="hover:text-white">Hizmet Teslimatı</Link></li>
            </ul>
          </div>

          <div>
            <div className="label-caps mb-2.5 text-[10px]" style={{ color: "var(--gold)" }}>İletişim</div>
            <ul className="space-y-1.5 text-neutral-400 font-mono tracking-wide">
              <li className="flex items-start gap-1.5">
                <MapPin size={11} className="mt-0.5 shrink-0" style={{ color: "var(--gold)" }} />
                <span className="leading-relaxed">Hatay, Türkiye</span>
              </li>
              <li className="flex items-center gap-1.5">
                <Phone size={11} style={{ color: "var(--gold)" }} />
                <a href="tel:+905349646703" className="hover:text-white">+90 534 964 67 03</a>
              </li>
              <li className="flex items-center gap-1.5">
                <Mail size={11} style={{ color: "var(--gold)" }} />
                <a href="mailto:milyemsoft@gmail.com" className="hover:text-white break-all">milyemsoft@gmail.com</a>
              </li>
              <li><Link to="/iletisim" className="hover:text-white underline underline-offset-2">Destek Formu</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-4 border-t border-white/6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-[10px] font-mono tracking-widest text-neutral-500">
          <div data-testid="premium-footer-copyright">
            © 2026 <span style={{ color: "var(--gold)" }}>Mustafa Yıldız</span> · MİLYEMSOFT · Tüm Hakları Saklıdır.
          </div>
          <div>Precision Grade IV · v2026.02</div>
        </div>

        {/* Türk Patent Enstitüsü Marka Bandı — legal armor */}
        <div className="mt-4 pt-3 border-t border-white/5 flex justify-center" data-testid="premium-footer-tpe">
          <div
            className="inline-flex items-center gap-2 px-3 py-1.5 border text-[10px] font-mono tracking-widest uppercase"
            style={{
              borderColor: "rgba(212,175,55,0.28)",
              background: "linear-gradient(90deg, rgba(212,175,55,0.04), rgba(212,175,55,0.10), rgba(212,175,55,0.04))",
              color: "var(--gold)",
            }}
          >
            <span style={{ fontFamily: "serif" }}>MİLYEMSOFT®</span>
            <span className="text-neutral-500">·</span>
            <span className="text-neutral-400">Türk Patent Enstitüsü nezdinde marka başvurusu kayıtlıdır</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
